module.exports = __webpack_public_path__ + "static/media/OpenSans.67e0ecdd.woff";